import React, { useState, useEffect } from "react";
import { Button, Segment, Select, Header, Icon } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListCompetence,
  CompetenceForm,
} from "../../../components/Admin/Competence";
import { Subject, Grade, Level } from "../../../api";
import { useAuth } from "../../../hooks";
import "./Competence.scss";

const subjectController = new Subject();
const gradeController = new Grade();
const levelController = new Level();

export function Competence() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const { accessToken } = useAuth();

  const [subjects, setSubjects] = useState([]);
  const [levels, setLevels] = useState([]);
  const [grades, setGrades] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  // Load subjects
  useEffect(() => {
    (async () => {
      try {
        const response = await subjectController.getSubjects(accessToken);
        const subjectOptions = [
          { key: "", value: "", text: "Selecciona asignatura" },
          ...response.map((subject) => ({
            key: subject.id,
            value: subject.id,
            text: subject.name,
          })),
        ];
        setSubjects(subjectOptions);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  // Load levels
  useEffect(() => {
    (async () => {
      try {
        const response = await levelController.getLevels(accessToken);
        const levelOptions = [
          { key: "", value: "", text: "Selecciona nivel" },
          ...response.map((level) => ({
            key: level.id,
            value: level.id,
            text: level.name,
          })),
        ];
        setLevels(levelOptions);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  // Load grades by selected level
  useEffect(() => {
    if (!selectedLevel) return;
    (async () => {
      try {
        setGrades([]);
        setSelectedGrade("");
        const response = await gradeController.getGradesByLevelId(
          selectedLevel,
          accessToken,
        );
        const gradeOptions = [
          { key: "", value: "", text: "Selecciona grado" },
          ...response.map((grade) => ({
            key: grade.id,
            value: grade.id,
            text: grade.name,
          })),
        ];
        setGrades(gradeOptions);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [selectedLevel, accessToken]);

  return (
    <>
      <div className="competence-page">
        <div className="competence-page__header">
          <Button
            className="competence-page__add"
            primary
            onClick={onOpenCloseModal}
          >
            Nueva Competencia
          </Button>
        </div>

        <div className="competence-page__filters">
          <Select
            clearable
            className="competence-page__filter-select edunova-select"
            value={selectedSubject}
            options={subjects}
            onChange={(_, data) => setSelectedSubject(data.value)}
            placeholder="Selecciona asignatura"
          />
          <Select
            className="competence-page__filter-select edunova-select"
            clearable
            value={selectedLevel}
            options={levels}
            onChange={(_, { value }) => {
              setSelectedLevel(value || null);
              setGrades([]);
              setSelectedGrade("");
            }}
            placeholder="Selecciona nivel"
          />
          <Select
            clearable
            className="competence-page__filter-select edunova-select"
            value={selectedGrade}
            options={grades}
            onChange={(_, data) => setSelectedGrade(data.value)}
            placeholder="Selecciona grado"
            disabled={grades.length === 0}
          />
        </div>

        <div className="competence-page__content">
          <Segment>
            <ListCompetence
              reload={reload}
              subjectId={selectedSubject}
              gradeId={selectedGrade}
              onReload={onReload}
            />
          </Segment>
        </div>
      </div>
      <BasicModal
        show={showModal}
        size="small"
        close={onOpenCloseModal}
        title="Crear competencia"
      >
        <CompetenceForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          defaultSubjectId={selectedSubject}
          defaultLevelId={selectedLevel}
          defaultGradeId={selectedGrade}
        />
      </BasicModal>
    </>
  );
}
